<template>
  <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%">
    <div class="el-table__body-wrapper is-scrolling-none">
      <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
        <colgroup>
          <col width="180" />
          <col />
        </colgroup>
        <tbody>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>订单号</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">{{ order.orderNo }}</div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>用户</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">{{ order.userName }}</div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>商品</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">
                <el-link :href="getUrl()" :underline="false" target="_blank" type="primary">
                  {{ order.resourceTitle }}
                </el-link>
              </div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>金额</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">￥{{ order.amount.toFixed(2) }}</div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>支付方式</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">
                {{ getChannel() }}
              </div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>支付时间</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">
                {{ order.createdDate }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="el-table__column-resize-proxy" style="display: none"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IOrder } from '@/types/models';
import utils from '@/utils';

export default defineComponent({
  props: {
    order: {
      type: Object as PropType<IOrder>,
      required: true,
    },
  },
  methods: {
    getChannel() {
      return utils.getPayChannel(this.order.channel);
    },

    getUrl() {
      return utils.getResourceUrl(this.order.resourceType, this.order.resourceId);
    },
  },
});
</script>
